import createIcon from '../../createIcon';

/**
 * @component @name SwapHoriz
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi45OSAxMUwzIDE1TDYuOTkgMTlWMTZIMTRWMTRINi45OVYxMVpNMjEgOUwxNy4wMSA1VjhIMTBWMTBIMTcuMDFWMTNMMjEgOVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SwapHoriz = createIcon('SwapHoriz', [
  [
    'path',
    {
      d: 'M6.99 11L3 15L6.99 19V16H14V14H6.99V11ZM21 9L17.01 5V8H10V10H17.01V13L21 9Z',
      key: '1g58ts',
    },
  ],
]);

export default SwapHoriz;
